export interface esferasOption {
  value: number;
  label: string;
}

export const esferasOptions: esferasOption[] = [
  {
    value: 1,
    label: 'Municipal',
  },
  {
    value: 2,
    label: 'Estadual',
  },
  {
    value: 3,
    label: 'Federal',
  },
  {
    value: 4,
    label: 'Distrital',
  },
  {
    value: 5,
    label: 'Privado',
  },
  {
    value: 6,
    label: 'Estatais',
  },
];
